export const fromLongCodesToCurrency = {
    ar_AE: 'USD',
    de_DE: 'EUR',
    en_US: 'USD',
    es_ES: 'EUR',
    fr_FR: 'EUR',
    hi_IN: 'INR',
    hu_HU: 'HUF',
    id_ID: 'IDR',
    it_IT: 'EUR',
    ja_JP: 'JPY',
    ko_KO: 'KRW',
    pl_PL: 'PLN',
    pt_PT: 'USD',
    ro_RO: 'RON',
    ru_RU: 'RUB',
    tr_TR: 'TRY',
    vi_VN: 'USD',
    uz_UZ: 'USD',
    ky_KY: 'USD',
    fil_FIL: 'USD',
    default: 'USD',
};

// true - two decimal places
export const currencyAppearance = {
    USD: true,
    EUR: true,
    INR: true,
    HUF: false,
    IDR: false,
    JPY: false,
    KRW: false,
    RUB: true,
    TRY: true,
    VND: false,
};

export const fromShortCodesToCurrency = {
    ar: 'USD',
    de: 'EUR',
    en: 'USD',
    es: 'EUR',
    fr: 'EUR',
    hi: 'INR',
    hu: 'HUF',
    id: 'IDR',
    it: 'EUR',
    ja: 'JPY',
    ko: 'KRW',
    pl: 'PLN',
    pt: 'USD',
    ro: 'RON',
    ru: 'RUB',
    tr: 'TRY',
    vi: 'USD',
    uz: 'USD',
    ky: 'USD',
    fil: 'USD',
    default: 'USD',
};

